import BankAccounts from "./BankAccounts";
import FundsTimeline from "./FundsTimeline";
import Info from "./Info";

const Account = {
  BankAccounts,
  Info,
  FundsTimeline,
};

export default Account;
